<template>
  <section id="about" class="section-padding fade-in-up">
    <div class="container flex flex-col">
      <div class="about-module-container">
        <div class="text-center mb-4">
          <h2 class="section-title">关于协会</h2>
          <div class="section-divider w-20 mx-auto"></div>
        </div>

        <div class="council-intro">
          <h3 class="council-title">协会理事会</h3>
          <div class="council-container">
            <div v-for="(section, index) in parsedCouncilData" :key="index" class="council-row">
              <div class="council-title-col">{{ section.title }}</div>
              <div :class="['council-members-col', { 'council-members-col-flex': ['名誉理事长', '专家委员会主任', '理事长', '秘书长'].includes(section.title) }]">
                <span v-for="(member, idx) in section.members" :key="idx" class="council-member">
                  <span v-html="padName(member.name)"></span> {{ member.company }}{{ member.position }}
                </span>
              </div>
            </div>

            <div v-if="parsedCouncilLinks.length > 0" class="council-links">
              <a v-for="(link, idx) in parsedCouncilLinks" :key="idx" :href="link.url" class="council-link">{{ link.text }}</a>
            </div>
          </div>
        </div>

        <div class="flex justify-center items-center pt-8 pb-4">
          <div class="flex gap-8 justify-center">
            <button class="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-full hover:bg-gray-100 transition-all duration-300 w-48 h-48 shadow-sm" @click="goToArticle('协会简介')">
              <span class="text-lg font-semibold text-gray-800 mb-1">协会简介</span>
              <i class="fa fa-chevron-right text-gray-400 mt-2"></i>
            </button>
            <button class="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-full hover:bg-gray-100 transition-all duration-300 w-48 h-48 shadow-sm" @click="goToArticle('协会章程')">
              <span class="text-lg font-semibold text-gray-800 mb-1">协会章程</span>
              <i class="fa fa-chevron-right text-gray-400 mt-2"></i>
            </button>
            <button class="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-full hover:bg-gray-100 transition-all duration-300 w-48 h-48 shadow-sm" @click="goToArticle('入会须知')">
              <span class="text-lg font-semibold text-gray-800 mb-1">入会须知</span>
              <i class="fa fa-chevron-right text-gray-400 mt-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { api } from '../api'

export default {
  name: 'AboutSection',
  data() {
    return {
      aboutArticle: null,
      loading: false,
      aboutArticles: {}
    }
  },
  computed: {
    parsedCouncilData() {
      if (this.aboutArticle && this.aboutArticle.contentHtml) {
        const content = this.aboutArticle.contentHtml.trim()

        if (content.startsWith('<council>')) {
          try {
            return this.parseXmlToCouncilData(content)
          } catch (e) {
            console.warn('XML解析失败:', e)
          }
        }

        if (content.startsWith('[')) {
          try {
            return JSON.parse(content)
          } catch (e) {
            console.warn('JSON解析失败:', e)
          }
        }
      }

      return []
    },
    parsedCouncilLinks() {
      if (this.aboutArticle && this.aboutArticle.contentHtml) {
        const content = this.aboutArticle.contentHtml.trim()

        if (content.startsWith('<council>')) {
          try {
            return this.parseXmlToLinks(content)
          } catch (e) {
            console.warn('解析链接失败:', e)
          }
        }
      }

      return []
    }
  },
  async mounted() {
    await this.loadAboutData()
  },
  methods: {
    padName(name) {
      if (!name) return ''
      const chars = name.replace(/\s/g, '')
      if (chars.length === 2) {
        return chars[0] + '&nbsp;&nbsp;&nbsp;&nbsp;' + chars[1]
      }
      return chars
    },
    parseXmlToCouncilData(xmlString) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(xmlString, 'text/xml')
      const sections = doc.querySelectorAll('section')
      const data = []

      sections.forEach(section => {
        const title = section.getAttribute('title')
        const members = []
        section.querySelectorAll('member').forEach(member => {
          members.push({
            name: member.getAttribute('name'),
            company: member.getAttribute('company'),
            position: member.getAttribute('position')
          })
        })
        data.push({ title, members })
      })
      return data
    },
    parseXmlToLinks(xmlString) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(xmlString, 'text/xml')
      const links = doc.querySelectorAll('link')
      const result = []

      links.forEach(link => {
        result.push({
          text: link.getAttribute('text'),
          url: link.getAttribute('url')
        })
      })

      return result
    },
    async loadAboutData() {
      try {
        this.loading = true
        const categories = await api.getCategories()
        const aboutCategories = categories.filter(cat => cat.firstLevelModule === '关于协会')

        if (aboutCategories.length > 0) {
          for (const category of aboutCategories) {
            if (category.single) {
              try {
                const article = await api.getArticleDetail(category.id)
                if (article) {
                  if (category.secondLevelModule === '理事会介绍') {
                    this.aboutArticle = article
                  }
                  this.aboutArticles[category.secondLevelModule] = category.id
                }
              } catch (detailError) {
                console.error(`获取${category.secondLevelModule}文章详情失败:`, detailError)
              }
            } else {
              const articles = await api.getArticles(category.id)
              if (articles.rows && articles.rows.length > 0) {
                this.aboutArticles[category.secondLevelModule] = articles.rows[0].id
              }
            }
          }
        }

        console.log('Loaded about articles:', this.aboutArticles)
      } catch (error) {
        console.error('加载关于协会数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    goToArticle(title) {
      const articleId = this.aboutArticles[title]
      if (articleId) {
        this.$router.push(`/article/${articleId}`)
      } else {
        alert('暂未找到对应的文章')
      }
    }
  }
}
</script>

<style scoped>
.section-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--accent), transparent);
  margin: 1rem auto;
  box-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
}

.section-padding {
  background-color: var(--bg);
  position: relative;
  overflow: hidden;
  padding: 16px 0;
}

.about-module-container {
  background: #ffffff;
  border-radius: 32px;
  box-shadow: 0 20px 40px -15px rgba(37,99,235,0.08);
  padding: 48px 40px;
  margin-bottom: 0;
  border: 1px solid rgba(37,99,235,0.12);
}

.section-padding::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 30% 70%, rgba(96, 165, 250, 0.1) 0%, transparent 60%);
  pointer-events: none;
  z-index: 0;
}

.container {
  position: relative;
  z-index: 1;
}

.council-intro {
  background: var(--surface);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
  padding: 32px;
}

.council-title {
  text-align: center;
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--accent);
  margin-bottom: 24px;
}

.council-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.council-row {
  display: flex;
  align-items: flex-start;
}

.council-title-col {
  width: 130px;
  flex-shrink: 0;
  color: var(--accent);
  font-weight: 600;
  font-size: 15px;
  padding-top: 2px;
  padding-right: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.council-members-col {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  max-width: 100%;
  align-items: start;
}

.council-members-col-flex {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.council-member {
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
  word-break: break-word;
}

.council-links {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-top: 24px;
  padding-top: 16px;
}

.council-link {
  color: var(--accent);
  font-size: 15px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 4px;
  transition: all 0.3s ease;
}

.council-link:hover {
  color: var(--accent-light);
  text-decoration-color: var(--accent-light);
}

#about button {
  background: var(--surface);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
  border-radius: 50px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

#about button:hover {
  /*transform: translateY(-8px) scale(1.015);*/
  box-shadow: 0 15px 35px -10px rgba(37, 99, 235, 0.15), 0 0 20px rgba(96, 165, 250, 0.2);
  border-color: rgba(96, 165, 250, 0.3);
  background: rgba(96, 165, 250, 0.1);
}

#about button span.text-lg {
  color: var(--text-primary);
  font-weight: 600;
}

#about button span.text-sm {
  color: var(--text-secondary);
}

#about button i {
  color: var(--accent);
  transition: transform 0.3s ease;
}

#about button:hover i {
  /*transform: translateX(4px);*/
  color: var(--accent-light);
}

@media (max-width: 768px) {
  .section-padding {
    padding: 48px 0;
  }

  .about-module-container {
    padding: 32px 24px;
  }

  .council-intro {
    padding: 24px;
  }

  .council-row {
    flex-direction: column;
  }

  .council-title-col {
    width: 100%;
    margin-bottom: 8px;
  }

  .council-members-col {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px 16px;
  }

  .council-links {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .gap-8 {
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .text-3xl {
    font-size: 1.75rem;
  }

  .text-2xl {
    font-size: 1.5rem;
  }

  .w-48, .h-48 {
    width: 120px;
    height: 120px;
  }

  .gap-8 {
    gap: 1rem;
  }

  #about button span.text-lg {
    font-size: 1rem;
  }

  #about button span.text-sm {
    font-size: 0.75rem;
  }

  .council-members-col {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
